/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleMinimalDto
 */
export interface RoleMinimalDto {
    /**
     * Unique identifier of the role
     * @type {string}
     * @memberof RoleMinimalDto
     */
    roleId: string;
    /**
     * Name of the role
     * @type {string}
     * @memberof RoleMinimalDto
     */
    name: string;
    /**
     * Whether this role is the default role
     * @type {boolean}
     * @memberof RoleMinimalDto
     */
    isDefault: boolean;
    /**
     * Whether this role is public
     * @type {boolean}
     * @memberof RoleMinimalDto
     */
    isPublic: boolean;
}

/**
 * Check if a given object implements the RoleMinimalDto interface.
 */
export function instanceOfRoleMinimalDto(value: object): value is RoleMinimalDto {
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('isPublic' in value) || value['isPublic'] === undefined) return false;
    return true;
}

export function RoleMinimalDtoFromJSON(json: any): RoleMinimalDto {
    return RoleMinimalDtoFromJSONTyped(json, false);
}

export function RoleMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'],
        'name': json['name'],
        'isDefault': json['isDefault'],
        'isPublic': json['isPublic'],
    };
}

export function RoleMinimalDtoToJSON(json: any): RoleMinimalDto {
    return RoleMinimalDtoToJSONTyped(json, false);
}

export function RoleMinimalDtoToJSONTyped(value?: RoleMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'name': value['name'],
        'isDefault': value['isDefault'],
        'isPublic': value['isPublic'],
    };
}

